/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */
import * as z from 'zod';

export const RecommendationResultSchema = z.object({
  collectionCount: z.number(),
});
export type RecommendationResult = z.infer<typeof RecommendationResultSchema>;
